module.exports = __webpack_public_path__ + "static/media/viewww.2f259754.svg";